module.exports = __webpack_public_path__ + "img/test-querenfanhui.ce74f1b6.png";